module.exports = __webpack_public_path__ + "7157ca916833731c51f3917d0dbc7a04.png";